import { aiInRecruitingImplementationSectionData } from 'constants/AiInRecruiting'
import styles from './AiInRecruitingImplementationSection.module.css'

const AiInScoringImplementationSection = () => {
  const { title, subtitle, items } = aiInRecruitingImplementationSectionData

  return (
    <section className={styles.implementationSection}>
      <div className="container">
        <div className="row mb-5">
          <h2 className={styles.sectionTitle}>{title}</h2>
          <p className={styles.sectionSubtitle}>{subtitle}</p>
        </div>
        <div className={styles.itemOuter}>
          {items.map((item, i) => (
            <div key={i} className={styles.item}>
              <div className={styles.number}>{i + 1}</div>
              <h3 className={styles.itemTitle}>{item.title}</h3>
              <p className={styles.itemDesc}>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default AiInScoringImplementationSection
